import queryString from "query-string";

/**
 * Reads the `username` (email) from a login-flow URL query string.
 *
 * `query-string` follows the application/x-www-form-urlencoded rule where a bare
 * `+` decodes to a space, so `?username=janardh+k@x.com` parses to
 * `"janardh k@x.com"`. Emails in this app never legitimately contain a space, and
 * `+` is a valid, common local-part character (gmail-style tags), so a decoded
 * space here can only be a `+` that was put in the URL unencoded (a link built
 * before the encodeURIComponent fix, a hand-typed/bookmarked URL, a back-button
 * hit on a stale history entry). Restore it so the value handed to Cognito
 * (Auth.confirmSignUp / resend-code / password-reset) matches the account the
 * verification code was actually issued for -- otherwise Cognito returns
 * CodeMismatchException.
 */
export function getUsernameParam(search: string): string | undefined {
  const raw = queryString.parse(search).username;
  const value = Array.isArray(raw) ? raw[0] : raw;
  if (typeof value !== "string" || value.length === 0) return undefined;
  return value.replace(/ /g, "+");
}
